import apis from './config/index'
import setting from '../setting'
import log from "../common/log"

log.capsule(setting.releases.description, setting.releases.version)

export default apis;



// WEBPACK FOOTER //
// ./src/api/apiConfig.js